import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import assistant from '../../public/images/menu-img/logo_small.png';
import user from '../../public/images/menu-img/user3.png';
import DesginHomeHead from '../DesignHomeHead/DesignHomeHead';
import { FormattedMessage, useIntl } from 'react-intl';
import remarkGfm from 'remark-gfm';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import 'primereact/resources/themes/saga-blue/theme.css';  // PrimeReact tema CSS
import 'primereact/resources/primereact.min.css';         // PrimeReact temel CSS
import 'primeicons/primeicons.css';  
const { dracula } = require('react-syntax-highlighter/dist/cjs/styles/prism'); // 'esm' yerine 'cjs' kullanın

const DesignHomeMessage = () => {
  const { formatMessage } = useIntl();
const [anyLongMessage, setAnyLongMessage] = useState(false);
  const [messages, setMessages] = useState([
    {
      text: formatMessage({ id: 'Home.design.text' }),
      sender: 'assistant',
      date: new Date().toLocaleTimeString(),
      name: formatMessage({ id: 'Home.design.assistant' }),
    }
  ]);
  const [newMessage, setNewMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [questionCount, setQuestionCount] = useState(0); // Kullanıcı tarafından sorulan soru sayısı

  useEffect(() => {
    // Soru sayısı değiştiğinde localStorage'a kaydet
    localStorage.setItem('questionCount', questionCount.toString());
  }, [questionCount]);

  const handleSendMessage = async () => {
    if (newMessage.trim()) {
      const userMessage = {
        text: newMessage,
        sender: 'user',
        date: new Date().toLocaleTimeString(),
        name: formatMessage({ id: 'Home.design.user' }),
      };
      setMessages([...messages, userMessage]);
      setNewMessage('');
      setQuestionCount(questionCount + 1); // Increment question count
  
      if (questionCount < 2) {
        setLoading(true); // Set loading state during API call
        try {
          const response = await fetch('/api/home_gpt', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ message: newMessage }),
          });
  
          const data = await response.json();
  
          const assistantMessage = {
            text: '', // Initially empty text to build the letter-by-letter effect
            sender: 'assistant',
            date: new Date().toLocaleTimeString(),
            name: formatMessage({ id: 'Home.design.assistant' }),
          };
  
          // Initialize the message to start the typing effect
          setMessages((prevMessages) => [...prevMessages, assistantMessage]);
  
          // Function to display message letter by letter
          let currentText = '';
          let charIndex = 0;
          const intervalId = setInterval(() => {
            if (charIndex < data.response.length) {
              currentText += data.response[charIndex];
              setMessages((prevMessages) => {
                const updatedMessages = [...prevMessages];
                updatedMessages[updatedMessages.length - 1] = {
                  ...assistantMessage,
                  text: currentText, // Update text progressively
                };
                return updatedMessages;
              });
              charIndex++;
            } else {
              clearInterval(intervalId); // Clear the interval once all letters are displayed
            }
          }, 10); // Adjust the delay (50ms) for typing speed
  
        } catch (error) {
          console.error('API error:', error);
        } finally {
          setLoading(false);
        }
      } else {
        // Show registration message if question limit reached
        const registrationMessage = {
          text: formatMessage({
            id: 'Home.design.registerMessage',
            defaultMessage: 'LLMWizard’a kayıt olarak konuşmaya devam edebilirsiniz.',
          }),
          sender: 'assistant',
          date: new Date().toLocaleTimeString(),
          name: formatMessage({ id: 'Home.design.assistant' }),
        };
        setMessages((prevMessages) => [...prevMessages, registrationMessage]);
      }
    }
  };

  useEffect(() => {
     setAnyLongMessage( messages.some(message => message.text.length > 200))


  },[messages])

  return (
    <>
        <div className={`chat-container ${anyLongMessage ? 'large' : ''}`}>
        <div className={`message-container ${anyLongMessage ? 'large' : ''}`}>
          <div className="message-list">
            {messages.map((message, index) => (
              <div
                key={index}
                className={`message-item ${
                  message.sender === 'user' ? 'user-message-item' : 'assistant-message-item'
                }`}
              >
                <div className="message-avatar">
                  <Image
                    src={message.sender === 'user' ? user : assistant}
                    alt={message.name}
                    width={40}
                    height={40}
                    className="avatar-image"
                  />
                </div>
                <div className={`message-bubble ${message.sender}`}>
                  <div className="message-header">
                    <span className="message-name">{message.name}</span>
                    <span className="message-date">{message.date}</span>
                  </div>
                  <div className="message-text">
                    <ReactMarkdown
                      remarkPlugins={[remarkGfm]}
                      rehypePlugins={[rehypeRaw]}
                      components={{
                        code({ node, inline, className, children, ...props }) {
                          const match = /language-(\w+)/.exec(className || '');
                          return !inline && match ? (
                            <SyntaxHighlighter
                              style={dracula}
                              language={match[1]}
                              PreTag="div"
                              {...props}
                            >
                              {String(children).replace(/\n$/, '')}
                            </SyntaxHighlighter>
                          ) : (
                            <code className={className} {...props}>
                              {children}
                            </code>
                          );
                        }
                      }}
                    >
                      {message.text}
                    </ReactMarkdown>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="message-input-container">
            <input
              type="text"
              value={newMessage}
              onChange={(e) => setNewMessage(e.target.value)}
              placeholder={formatMessage({ id: 'Home.design.placeholder' })}
              disabled={loading} // Mesaj gönderilirken input disable
            />
            <button
              style={{ flexDirection: 'row', display: 'flex', backgroundColor: loading ? 'gray' : '#123e7b' }}
              onClick={handleSendMessage}
              disabled={loading || newMessage.trim() === ''} // Soru sınırına ulaşıldığında buton disable
            >
              <div><FormattedMessage id="setup.send" /></div>
              <i style={{ marginLeft: 5 }} className="feather-send"></i>
            </button>
          </div>
        </div>
      </div>

      <style jsx>{`
        html, body {
          margin: 0;
          padding: 0;
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #f1f5f9;
        }

        .chat-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 70vh;
          width: 100vw;
          padding: 20px;          
          transition: height 0.3s ease, width 0.3s ease;
        }

        .chat-container.large {
          height: 90vh;
          width: 100%;
        }

        .message-container {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
          max-width: 900px;
          min-height: 300px;
          height: 500px;
          border: 1px solid #e2e8f0;
          border-radius: 16px;
          background: radial-gradient(circle, #e0e0e0 15%, #ffffff 76%); /* Corners gray, center white */
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
          padding: 20px;
          transition: height 0.3s ease, width 0.3s ease;
        }

        .message-container.large {
          height: 700px;
          width: 1200px;
        }

        .message-list {
          flex-grow: 1;
          overflow-y: auto;
          padding-right: 10px;
        }

        .message-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 12px;
        }

        .message-avatar {
          margin-right: 12px;
        }

        .avatar-image {
          border-radius: 50%;
          object-fit: cover;
        }

        .message-bubble {
          padding: 12px 16px;
          border-radius: 24px;
          max-width: 96%;
          word-wrap: break-word;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          font-size: 15px;
          line-height: 1.5;
          position: relative;
        }

        .message-header {
          display: flex;
          justify-content: space-between;
          margin-bottom: 8px;
          font-size: 12px;
          color: #6b7280;
        }

        .message-name {
          font-weight: bold;
        }

        .message-date {
          color: #9ca3af;
        }

        .message-text {
          font-size: 15px;
        }

        .user-message-item .message-bubble {
          background-color: #ffffff; /* Beyaz arka plan */
          color: #000000; /* Siyah metin rengi */
          min-width: 200px;
        }

        .assistant-message-item .message-bubble {
          background-color: #ffbd4c;
          color: #123e7b;
          align-self: flex-start;
          margin-right: auto;
        }

        .message-input-container {
          display: flex;
          align-items: center;
          padding-top: 12px;
          padding-left: 0px;
        }

        .message-input-container input {
          flex-grow: 1;
          padding: 12px;
          border-radius: 25px;
          border: 1px solid #e2e8f0;
          outline: none;
          padding-left: 20px;
          font-size: 14px;
          box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
        }

        .message-input-container button {
          margin-left: 12px;
          padding: 12px 24px;
          border: none;
          border-radius: 25px;
          background-color: #123e7b;
          color: white;
          font-weight: bold;
          cursor: pointer;
          transition: background-color 0.3s ease, transform 0.2s ease;
        }

        .message-input-container button:hover {
          background-color: #0d2a5a;
          transform: translateY(-2px);
        }

        .message-input-container button:active {
          transform: translateY(1px);
        }

        .message-list::-webkit-scrollbar {
          width: 8px;
        }

        .message-list::-webkit-scrollbar-thumb {
          background-color: #123e7b;
          border-radius: 4px;
        }

        .message-list::-webkit-scrollbar-track {
          background-color: #f1f5f9;
        }
      `}</style>
    </>
  );
};

export default DesignHomeMessage;
